// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9995) return "static/chunks/9995-07e3fbd7870d8e29.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3841":"a0dcac8544317ccb","5562":"e73745bccc9d3e35","5803":"d77a3e8575c4ee03"}[chunkId] + ".js";
};